import React from 'react'
import PropTypes from 'prop-types'
import { Spacing50, Divider } from 'styles/sharedStyle'
import Button from 'components/Button'
import Link from 'components/Link'
import GA4 from 'utils/GA4'
import {
  BrandTickerWrapper,
  BrandTickerList,
  BrandTickerListLabel,
  BrandTickerRow,
  BrandTickerCTAContainer,
  BrandTickerCTADivider,
} from './BrandTicker.style'

const BrandTicker = ({ tickerText, ctaCopy, ctaUrl, villageSlug }) => (
  <BrandTickerWrapper role="presentation" dir="ltr">
    <Spacing50 />
    {tickerText.map((label, index) => (
      <BrandTickerRow key={`${label}_${index.toString()}`}>
        <BrandTickerList fontSize={[32, null, 40]} index={index}>
          {[...label.split(','), ...label.split(',')].map((text, idx) => (
            <BrandTickerListLabel key={`${text}_${idx.toString()}`}>
              {text.trim()}
            </BrandTickerListLabel>
          ))}
        </BrandTickerList>
      </BrandTickerRow>
    ))}
    {ctaCopy && ctaUrl ? (
      <BrandTickerCTAContainer>
        <Spacing50 />
        <BrandTickerCTADivider as={Divider} />
        <Spacing50 />
        <Button
          as={Link}
          to={ctaUrl}
          onClick={() =>
            GA4('brand_ticker_CTA', {
              cta_label: ctaCopy,
              village_name: villageSlug,
            })
          }>
          {ctaCopy}
        </Button>
      </BrandTickerCTAContainer>
    ) : null}
    <Spacing50 />
  </BrandTickerWrapper>
)

BrandTicker.propTypes = {
  tickerText: PropTypes.arrayOf(PropTypes.string).isRequired,
  ctaCopy: PropTypes.string,
  ctaUrl: PropTypes.string,
  villageSlug: PropTypes.string,
}

BrandTicker.defaultProps = {
  ctaUrl: '',
  ctaCopy: '',
  villageSlug: '',
}

export default BrandTicker
